import { render, staticRenderFns } from "./PriceRecordsTable.vue?vue&type=template&id=c42bbff6&"
import script from "./PriceRecordsTable.vue?vue&type=script&lang=js&"
export * from "./PriceRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceRecordsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports